import React, { Suspense } from "react";
import "./App.css";
import "./styles/global.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import { createBrowserHistory } from "history";
import { unstable_HistoryRouter as HistoryRouter } from "react-router-dom";

import RootWrapper from "./wrappers/RootWrapper";
import { ConfigProvider } from "antd";
import ja_JP from "antd/lib/locale/ja_JP";
import moment from "moment";

export const history = createBrowserHistory();
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 24 * 3600 * 1000, // cache for 1 day
    },
  },
});
moment.updateLocale("jp", {
  weekdaysMin: ["日", "月", "火", "水", "木", "金", "土"],
  monthsShort: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月",
  ],
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <HistoryRouter history={history as any}>
        <Suspense fallback={null}>
          <ConfigProvider locale={ja_JP}>
            <RootWrapper />
          </ConfigProvider>
        </Suspense>
      </HistoryRouter>
    </QueryClientProvider>
  );
}

export default App;
